Controller.$inject = [];

function Controller() {

}

export function HuiInputSelectWrapper() {
    return {
        restrict: 'E',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <div class="dropdown" ng-transclude></div>
            `;
        }
    };
}


